import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

export type { ColorScheme }

export const TAG_HEIGHT = 24

const tokens = {
  dark: {
    bg: 'bg.label',
    bgArchived: 'bg.label-archived',
    text: 'text.label',
    textArchived: 'text.label-archived',
  },
  light: {
    bg: 'light.bg.label',
    bgArchived: 'light.bg.label-archived',
    text: 'light.text.label',
    textArchived: 'light.text.label-archived',
  },
}

export const tagStyles = (
  isArchived: boolean,
  maxWidth?: string | number,
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  display: 'inline-flex',
  alignItems: 'center',
  height: `${TAG_HEIGHT}px`,
  px: '10px',
  borderRadius: '4px',
  fontFamily: "'Soehne Kraftig', sans-serif",
  fontWeight: '500',
  fontSize: '14px',
  fontStyle: 'normal',
  whiteSpace: 'nowrap',
  lineHeight: '20px',
  userSelect: 'none',
  bg: isArchived ? tokens[colorScheme].bgArchived : tokens[colorScheme].bg,
  color: isArchived
    ? tokens[colorScheme].textArchived
    : tokens[colorScheme].text,
  cursor: isArchived ? 'default' : undefined,
  ...(maxWidth !== undefined && {
    maxWidth,
    minWidth: 0,
  }),
})
